import React, {useState} from 'react';
//import './style.scss';
import {Spinner} from 'reactstrap';
import DeleteNudgeEmailModal from './modals/DeleteNudgeEmailModal';
import PreviewNudgeEmailModal from './modals/PreviewNudgeEmailModal';
import {sendNudgeEmail} from 'utils/api';
import {toast} from 'react-toastify';

function NudgeEmailListItem({item, refreshList}) {
    const [submitting, setSubmitting] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);

    // const convertDateString = (date) => {
    //     let stillUtc = moment.utc(date).toDate();
    //     return moment(stillUtc).local().format('MM/DD/YYYY hh:mm');
    // };

    const togglePreviewModal = () => setPreviewModalOpen(prevState => !prevState);
    const toggleDeleteModal = () => setDeleteModalOpen(prevState => !prevState);

    const sendEmail = async() => {
        try {
            setSubmitting(true);
            await sendNudgeEmail(item.id);
            // setSubmitting(false);
            await refreshList(true);
            setSubmitting(false);
            toast.success('Email successfully sent');
        } catch(err) {
            console.log(err);
            setSubmitting(false);
            toast.error('Unable to complete your request at this time')
        }
    };

    return (
        <tr className={`table_row`}>
            {deleteModalOpen && (
                <DeleteNudgeEmailModal
                    isOpen={deleteModalOpen}
                    toggle={toggleDeleteModal}
                    item={item}
                    refreshList={refreshList}
                />
            )}
            {previewModalOpen && (
                <PreviewNudgeEmailModal
                    isOpen={previewModalOpen}
                    toggle={togglePreviewModal}
                    item={item}
                    // refreshList={refreshList}
                />
            )}
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Entity Name</strong>
                <div className="table-title_container">
                    <span id={`title-${item.id}`}>{item.name}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Preview Email</strong>
                <div className="table-title_container">
                    <i className="fas fa-envelope" onClick={togglePreviewModal}/>
                </div>
            </td>
            {/*<td className="table_column" style={{verticalAlign: 'middle'}}>*/}
            {/*    <strong className="table_lable">Send Email</strong>*/}
            {/*    <div className="table-title_container">*/}
            {/*        <i className="fas fa-paper-plane"/>*/}
            {/*    </div>*/}
            {/*</td>*/}
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Email</strong>
                <div className="table-title_container">
                    <div style={{width: '60px', display: 'flex'}}>
                        {/*<i*/}
                        {/*    onClick={() => setEditModalOpen(prevState => !prevState)}*/}
                        {/*    className="feedsActions mr-2 fas fa-pencil-alt"*/}
                        {/*    title="Edit User"*/}
                        {/*/>*/}
                        <div className="mr-2">
                            {submitting ?
                                <Spinner style={{margin: '5px 5px 0', width: '15px', height: '15px', borderWidth: '2px'}}/>
                                :
                                <i
                                    onClick={() => sendEmail()}
                                    className="feedsActions fas fa-paper-plane"
                                    title="Send Email"/>
                            }
                        </div>

                        <i
                            onClick={toggleDeleteModal}
                            className="feedsActions fas fa-trash-alt"
                            title="Delete User"
                        />
                    </div>
                </div>
            </td>
        </tr>
    );
}

export default NudgeEmailListItem;